import Vue from "vue";
import Certificate from "./certificate";
import CertificateFoundationLayer from "./certificateFoundationLayer";
import CertificateElement from "./certificateElement";
import BaseCertificateElement from "./baseCertificateElement";

export default class CertificateFoundationLayerFactory {
  static create(parent: Certificate | BaseCertificateElement, json = {}) {
    const isNew = json["client_id"] === undefined;
    let foundationLayer = new CertificateFoundationLayer();

    if (isNew){
      json["sort_order"] = Object.keys(parent.certificate_foundation_layers).length;
    }

    foundationLayer.definePropertiesFrom(parent, json);
    foundationLayer.rootModel = foundationLayer.parent = parent;

    Vue.set(parent.certificate_foundation_layers, foundationLayer.client_id, foundationLayer);

    CertificateFoundationLayer.repo.add(foundationLayer);

    if (isNew) {
      parent.trackCreationDeletion(foundationLayer.client_id, null, foundationLayer.asJson(), foundationLayer);
    }

    if (parent instanceof Certificate){
      parent.saveChangesToStore();
    }

    return foundationLayer;
  }

  static remove(foundationLayer: CertificateFoundationLayer) {
    CertificateFoundationLayer.repo.remove(foundationLayer);
    foundationLayer.destroy();
  }
}